const MeetApprovedRequestApprovalValidation = async (formState) => {
  let errors = {};

  if (formState.meetName.trim() === '') {
    errors.meetName = 'Meet Name is required';
  } else if (formState.meetName.trim().length > 200) {
    errors.meetName = 'Meet Name cannot exceed 200 characters';
  }

  // if (formState.meetSanctionNumber.trim() === '') {
  //   errors.meetSanctionNumber = 'Sanction Number is required';
  // } else if (formState.meetSanctionNumber.trim().length > 20) {
  //   errors.meetSanctionNumber = 'Sanction Number cannot exceed 20 characters';
  // }

  return errors ? errors : {};
};

export default MeetApprovedRequestApprovalValidation;